import { CameraViewpoint } from "./CameraViewpoint";

export const CameraViewpointsSection = ({
  cameraViewpoints,
  cameraViewpointsLoading,
  selectedVideoId,
  handleCameraViewpointSelect,
  getFileUrl
}) => {
  return (
    <div className="bg-white rounded-lg shadow-lg p-4 md:p-6 min-h-[200px]">
      <h2 className="text-lg md:text-xl font-semibold text-gray-800 mb-3 md:mb-4">
        Camera Viewpoints
        {cameraViewpoints.length > 0 && (
          <span className="ml-2 text-sm font-normal text-gray-500">
            ({cameraViewpoints.length} videos)
          </span>
        )}
      </h2>
      
      <div className="transition-all duration-300 overflow-y-auto max-h-[calc(100%-3rem)]">
        {cameraViewpointsLoading ? (
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
            {[1, 2, 3, 4].map((i) => (
              <div
                key={i}
                className="w-full aspect-video bg-gray-200 animate-pulse rounded"
              />
            ))}
          </div>
        ) : cameraViewpoints.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-2 md:gap-3">
            {cameraViewpoints.map((viewpoint) => (
              <CameraViewpoint
                key={viewpoint.id}
                viewpoint={viewpoint}
                onSelect={handleCameraViewpointSelect}
                isSelected={selectedVideoId === viewpoint.id}
                getFileUrl={getFileUrl}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-8">
            <p className="text-sm text-gray-500">
              No camera viewpoints available
            </p>
            <p className="text-xs text-gray-400 mt-1">
              Select a video to view camera angles
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
